/**
 * Trims a multiline string by:
 * - Removing leading and trailing empty lines
 * - Removing indentation from each line
 * - Preserving single empty lines between content
 * - Collapsing multiple consecutive empty lines into one
 *
 * @param string - The input string to trim
 * @returns The trimmed string with normalized whitespace
 * @throws Error if the input is not a string
 */
function multilineTrim(string?: string): string {
  // Validate input is a string
  if (typeof string !== 'string') {
    throw new Error(`Can't parse string: ${string}`)
  }

  // Split the input string into lines
  const lines = string.split('\n')
  let result = ''
  let lastLineWasEmpty = false
  let startFound = false
  let buffer = ''

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]
    const isLineEmpty = line.trim() === ''

    // Skip leading empty lines until we find content
    if (!startFound) {
      if (!isLineEmpty) {
        startFound = true
        result = line.trim()
      }
      continue
    }

    // Handle empty lines between content
    // Only keep one empty line when multiple consecutive empty lines are found
    if (isLineEmpty) {
      if (!lastLineWasEmpty) {
        buffer = '\n'
        lastLineWasEmpty = true
      }
      continue
    }

    // Handle non-empty lines
    // Add the buffered newline (if any) and the trimmed content
    result += buffer + (result ? '\n' : '') + line.trim()
    buffer = ''
    lastLineWasEmpty = false
  }

  return result
}

export { multilineTrim }
